import React from 'react'
import {injectIntl} from 'react-intl'
import styled from 'styled-components'
import FormControl from '@mui/material/FormControl'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import Tooltip from '@mui/material/Tooltip'
import Snackbar from '@mui/material/Snackbar'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import {FileCopy} from '@mui/icons-material'
import PublicFields from 'components/PublicFields'
import Notifications from './Notifications'
import Tab from 'components/Tab'
import {getPublicFormFields, getPublicLink, getEmailEmissions, getEmailSubstitutions, getFormEmailOptions,
    getFieldsByType, getDateSubstitutions, getDurationSubstitutions} from 'utils/utils'
import {fieldtype} from 'utils/enums/fieldtype'
import {options} from 'utils/enums/options'

const types = ['create', 'update']

const settings = {
    readonly: false,
    now: false,
    autocomplete: null,
    optional: false,
    recipient: false,
    mandatory: false
}

const tabs = {
    general: {
        code: 'general'
    },
    notifications: {
        code: 'notifications'
    }
}

const Tabs = styled.div`
    display: flex;
    margin-bottom: 30px;
`

const Field = styled(TextField)`
	margin-bottom: 20px;
	width: 100%;
`

class PublicForm extends React.Component {
    constructor(props) {
        super(props)

        this.fields = getPublicFormFields(props.entity)
        this.emissions = getEmailEmissions(props.entity)
        this.substitutions = getEmailSubstitutions(props.entity)
        this.forms = getFormEmailOptions(props.entity)
        this.logicalFields = getFieldsByType(props.entity, fieldtype.check)
        this.dates = getDateSubstitutions(props.entity)
        this.numbers = getDurationSubstitutions(props.entity)

        this.state = {
            type: props.form ? props.form.type : types[0],
            name: props.form ? props.form.name : '',
            messages: props.form ?
                props.form.label.success || props.form.label.error || props.form.label.submit || props.form.label.title : false,
            title: props.form ? props.form.label.title : '',    
            success: props.form ? props.form.label.success : '',
            error: props.form ? props.form.label.error : '',
            submit: props.form ? props.form.label.submit : '',
            fields: [],
            order: [],
            notifications: props.form ? props.notifications : [],
            copy: false,
            tab: tabs.general.code
        }
    }

    componentDidMount() {
        if (this.props.form) {
            const fields = []

            this.props.form.fields.forEach(item => {
                const el = this.fields.find(obj => obj.id === item.fieldId)
                const field = {...item}
                
                if (el) {
                    fields.push(field)
                    if (el.uiType === fieldtype.linkedfield) {
                        this.props.fetchLinkedOptions(item.fieldId)
                    }
                } else if (item.subtitle) {
                    fields.push(field)
                }
            })

            this.setState({
                fields,
                order: fields.map(field => field.fieldId)
            })
        }
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleToggle = (e) => {
        if (e.target.name === 'messages') {
            if (e.target.checked) {
                this.setState({
                    messages: e.target.checked
                })
            } else {
                this.setState({
                    messages: e.target.checked,
                    title: '',
                    success: '',
                    error: '',
                    submit: ''
                })
            }
        } else {
            this.setState({
                [e.target.name]: e.target.checked
            })
        }
    }

    handleCreate = () => {
        const notifications = this.state.notifications.map(item => {
            return {
                ...item,
                id: item.id > 0 ? item.id : null
            }
        })

        this.props.createPublicForm({
            entityId: this.props.entity,
            name: this.state.name,
            type: this.state.type,
            fields: this.state.fields,
            notifications: [],
            label: {
                title: this.state.title,
                success: this.state.success,
                error: this.state.error,
                submit: this.state.submit
            }
        }, notifications)
        this.props.handleClose()
    }

    handleUpdate = () => {
        const notifications = this.state.notifications.map(item => {
            return {
                ...item,
                id: item.id > 0 ? item.id : null
            }
        })
        
        this.props.updatePublicForm({
            id: this.props.form.id,
            entityId: this.props.entity,
            name: this.state.name,
            type: this.state.type,
            fields: this.state.fields,
            notifications: this.props.form.notifications,
            label: {
                title: this.state.title,
                success: this.state.success,
                error: this.state.error,
                submit: this.state.submit
            }
        }, notifications)
        this.props.handleClose()
    }

    handleDelete = () => {
        this.props.deletePublicForm(this.props.form.id)
        this.props.handleClose()
    }

    updateField = (value, key, id) => {
        const fields = [...this.state.fields]
        const field = {...fields.find(item => item.fieldId === id)}
        const index = fields.findIndex(item => item.fieldId === id)

        if (settings[key] !== undefined) {
            Object.keys(settings).forEach(item => {
                field[item] = settings[item]
            })
        }

        field[key] = value
        fields.splice(index, 1, field)

        this.setState({ fields })
    }

    handleSelect = (data) => {
        const fields = [...this.state.fields]

        fields.push({
            fieldId: data.id,
            label: '',
            readonly: false,
            autocomplete: null,
            now: false,
            optional: false,
            recipient: false,
            mandatory: false,
            subtitle: ''
        })

        this.setState({
            fields,
            order: fields.map(field => field.fieldId)
        }, () => setTimeout(() => document.querySelector(`[data-field='${data.id}']`).select(), 200))
    }

    addSubtitle = () => {
        const fields = [...this.state.fields]
        const minId = fields.reduce((min, item) => min < item.fieldId ? min : item.fieldId, 0)
        const id = minId - 1
        
        fields.push({
            fieldId: id,
            label: '',
            readonly: false,
            autocomplete: null,
            now: false,
            optional: false,
            recipient: false,
            mandatory: false,
            subtitle: 'My subtitle'
        })

        this.setState({
            fields,
            order: fields.map(field => field.fieldId)
        }, () => setTimeout(() => document.querySelector(`[data-field='${id}']`).select(), 200))
    }

    deleteField = (id) => {
        const fields = this.state.fields.filter(item => item.fieldId !== id)
        this.setState({
            fields,
            order: fields.map(field => field.fieldId)
        })
    }

    deleteNotification = (id) => {
        const notifications = this.state.notifications.filter((item, index) => index !== id)

        this.setState({
            notifications
        })
    }

    createNotification = () => {
        const notifications = [...this.state.notifications]
        const minId = notifications.reduce((min, item) => min < item.id ? min : item.id, 0)
        const id = minId - 1

        notifications.push({
            entityId: this.props.entity,
            emissionPath: this.emissions[0].pathId,
            name: '',
            subject: '',
            fromEmail: '',
            fromName: '',
            cc: [],
            bcc: [],
            body: '',
            gdprOnly: false,
            type: 1,
            id
        })

        this.setState({
            notifications
        })
    }

    updateNotification = (key, value, num) => {
        const notifications = [...this.state.notifications]
        const notification = {...notifications.find((item, index) => index === num)}
        notification[key] = value
        notifications.splice(num, 1, notification)
        this.setState({ notifications })
    }

    onReorder = (fields, order) => {
        this.setState({
            order,
            fields
        })
    }

    handleCopy = () => {
        this.input.select()
        document.execCommand('copy')
        this.setState({ copy: true })
    }

    handleReset = () => {
        this.setState({ copy: false })
    }

	handleClone = () => {
        this.props.clonePublicForm(this.props.form.id)
        this.props.handleClose()
    }

    render() {
        const {intl} = this.props
        const link = this.props.form && this.state.type === types[0] ? getPublicLink(this.props.form.id) : undefined
        const validation = !this.state.name || !this.state.name.replace(/\s/g, '') ||
            this.state.notifications.find(obj => !obj.subject || !obj.fromName.replace(/\s/g, '') || !obj.fromEmail.replace(/\s/g, '')) ||
            !this.state.fields.length || this.state.fields.find(item =>
                item.autocomplete === true || (Array.isArray(item.autocomplete) && !item.autocomplete.length))

        return (
            <React.Fragment>
                <DialogTitle>
                    {this.props.form ?
                        intl.formatMessage({id: "sidebar.update_public_form"}) :
                        intl.formatMessage({id: "sidebar.create_public_form"})
                    }
                </DialogTitle>
                <DialogContent>
                    <Tabs>
                        {Object.values(tabs).map((item, index) =>
                            <Tab key={index} active={this.state.tab === item.code} onClick={() => this.setState({ tab: item.code })}>
                                {intl.formatMessage({id: `sidebar.public_form_${item.code}`})}
                            </Tab>
                        )}
                    </Tabs>
                    <React.Fragment>
                        {this.state.tab === tabs.general.code ?
                            <React.Fragment>
                                {this.props.form && this.state.type === types[0] &&
                                    <React.Fragment>
                                        <Field variant="standard"
                                            inputRef={el => this.input = el}
                                            value={link}
                                            label={intl.formatMessage({id: "sidebar.public_form_link"})}
                                            InputProps={{
                                                readOnly: true,
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <Tooltip
                                                            title={intl.formatMessage({id: "sidebar.copy_to_clipboard"})}
                                                            placement="top"
                                                        >
                                                            <FileCopy onClick={this.handleCopy} style={{fontSize: 18, cursor: 'pointer'}} />
                                                        </Tooltip>
                                                    </InputAdornment>
                                                )
                                            }}
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                        />
                                        <Snackbar
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'center',
                                            }}
                                            onClose={this.handleReset}
                                            open={this.state.copy}
                                            autoHideDuration={2000}
                                            message={intl.formatMessage({id: "sidebar.link_has_been_copied"})}
                                        />
                                    </React.Fragment>
                                }
                                <Field variant="standard"
                                    value={this.state.name}
                                    onChange={this.handleChange}
                                    label={intl.formatMessage({id: "sidebar.public_form_name"})}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    inputProps={{
                                        maxLength: global.LONG_NAME_MAX_LENGTH,
                                        name: 'name'
                                    }}
                                />
                                <FormControl sx={{marginBottom: '20px', width: '100%'}} variant="standard">
                                    <InputLabel>
                                        {intl.formatMessage({id: "sidebar.public_form_type"})}
                                    </InputLabel>
                                    <Select
                                        value={this.state.type}
                                        onChange={this.handleChange}
                                        inputProps={{
                                            name: 'type'
                                        }}
                                    >
                                        {types.map(item =>
                                            <MenuItem key={item} value={item}>
                                                {intl.formatMessage({id: `sidebar.type_record_${item}`})}
                                            </MenuItem>
                                        )}
                                    </Select>
                                </FormControl>
                                <div style={{marginBottom: '20px', lineHeight: 1.5}}>
                                    {intl.formatMessage({id: `sidebar.description_record_${this.state.type}`})}
                                </div>
                                <FormControlLabel
                                    sx={{
										marginBottom: '20px',
										width: '100%'
									}}
                                    control={
                                        <Checkbox
                                            checked={!!this.state.messages}
                                            onChange={this.handleToggle}
                                            inputProps={{
                                                name: 'messages'
                                            }}
                                        />
                                    }
                                    label={intl.formatMessage({id: "sidebar.text_messages"})}
                                />
                                {this.state.messages &&
                                    <React.Fragment>
                                        <Field variant="standard"
                                            value={this.state.title}
                                            onChange={this.handleChange}
                                            label={intl.formatMessage({id: "sidebar.title_message"})}
                                            placeholder={intl.formatMessage({id: "sidebar.title_message_placeholder"})}
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            inputProps={{
                                                name: 'title'
                                            }}
                                        />
                                        <Field variant="standard"
                                            value={this.state.success}
                                            onChange={this.handleChange}
                                            label={intl.formatMessage({id: "sidebar.success_message"})}
                                            placeholder={intl.formatMessage({id: "sidebar.success_message_placeholder"})}
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            inputProps={{
                                                name: 'success'
                                            }}
                                        />
                                        <Field variant="standard"
                                            value={this.state.error}
                                            onChange={this.handleChange}
                                            label={intl.formatMessage({id: "sidebar.error_message"})}
                                            placeholder={intl.formatMessage({id: "sidebar.error_message_placeholder"})}
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            inputProps={{
                                                name: 'error'
                                            }}
                                        />
                                        <Field variant="standard"
                                            style={{marginBottom: '30px'}}
                                            value={this.state.submit}
                                            onChange={this.handleChange}
                                            label={intl.formatMessage({id: "sidebar.submit_message"})}
                                            placeholder={intl.formatMessage({id: "sidebar.submit_message_placeholder"})}
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            inputProps={{
                                                name: 'submit'
                                            }}
                                        />
                                    </React.Fragment>
                                }
                                <PublicFields
                                    data={this.fields}
                                    list={this.state.fields}
                                    handleChange={this.updateField}
                                    deleteField={this.deleteField}
                                    handleSelect={this.handleSelect}
                                    handleClick={this.addSubtitle}
                                    values={this.props.linkedOptions}
                                    onReorder={this.onReorder}
                                    order={this.state.order}
                                    options={options.form[this.state.type]}
									isForm
                                />
                            </React.Fragment>
                            :
                            <Notifications
                                emissions={this.emissions}
                                notifications={this.state.notifications}
                                entity={this.props.entity}
                                handleDelete={this.deleteNotification}
                                handleCreate={this.createNotification}
                                handleUpdate={this.updateNotification}
                                substitutions={this.substitutions}
                                forms={this.forms}
                                fields={this.logicalFields}
                                dates={this.dates}
                                numbers={this.numbers}
                            />
                        }
                    </React.Fragment>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose} color="primary">
                        {intl.formatMessage({id: "app.confirm_cancel"})}
                    </Button>
                    {this.props.form &&
						<React.Fragment>
							<Button variant="contained"
								onClick={this.handleDelete}
								color="secondary"
							>
								{intl.formatMessage({id: "app.confirm_delete"})}
							</Button>
							<Button variant="contained"
								onClick={this.handleClone}
								color="primary"
							>
								{intl.formatMessage({id: "app.duplicate"})}
							</Button>
						</React.Fragment>
                    }
                    {this.props.form ?
                        <Button variant="contained"
                            disabled={!!validation}
                            onClick={this.handleUpdate}
                            color="primary"
                        >
                            {intl.formatMessage({id: "app.confirm_update"})}
                        </Button> :
                        <Button variant="contained"
                            disabled={!!validation}
                            onClick={this.handleCreate}
                            color="primary"
                        >
                            {intl.formatMessage({id: "app.confirm_save"})}
                        </Button>
                    }
                </DialogActions>
            </React.Fragment>
        )
    }
}

export default injectIntl(PublicForm)
